import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from "@angular/core";
import { AUTH_GUARD_FORBIDDEN_REDIRECTS } from "@app/shared/auth/tokens/auth-guard-forbidden-redirects.token";
import { resourceChatForbiddenRedirect } from "../helpers/resource-chat-link.helper";
import { IResourceChatDefinition } from "../interfaces/resource-chat-definition.interfaces";
import { RESOURCE_CHAT_DEFINITIONS } from "../services/resource-chat-registry.service";
import { ResourceChatMentionAlertService } from "../services/resource-chat-mention-alert.service";

/**
 * Enables resource chat for the application and registers the resources that use it.
 *
 * Call it once in `app.config.ts`, before any lazy feature can activate: a mention
 * notification or a message link must resolve its resource on a cold start, when
 * the resource's feature has never loaded. It also starts the mention alerts and
 * lets AuthGuard send a refused message link to its discussion.
 *
 * @param definitions - One configuration per resource type; see `IResourceChatDefinition`.
 * @returns Environment providers for the application config.
 */
export function provideResourceChat(...definitions: IResourceChatDefinition[]): EnvironmentProviders {
  return makeEnvironmentProviders([
    definitions.map(definition => ({ provide: RESOURCE_CHAT_DEFINITIONS, useValue: definition, multi: true })),
    { provide: AUTH_GUARD_FORBIDDEN_REDIRECTS, useFactory: resourceChatForbiddenRedirect, multi: true },
    provideAppInitializer(() => void inject(ResourceChatMentionAlertService)),
  ]);
}
